import { render, staticRenderFns } from "./CheckStep.vue?vue&type=template&id=05bcd1dc&"
import script from "./CheckStep.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CheckStep.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CheckStep.vue?vue&type=style&index=0&id=05bcd1dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports